/* eslint-disable react/prop-types */ // TODO: add props
import { ChecklistDescription } from 'edrolo/domains/exams';
import { Cross, Dash, Tick } from '../Icons';
import style from './ChecklistReflectionSummary.scss';

const ChecklistReflectionSummary = ({ reflections }) => {
  return (
    <>
      {reflections.map((reflection, i) => {
        return (
          <div className={style.checklistReflection} key={i}>
            <span className={style.checklistReflectionIcon}>
              {reflection.get('checked') ? (
                <Tick />
              ) : reflection.get('checked') === null ? (
                <Dash />
              ) : (
                <Cross />
              )}
            </span>
            <ChecklistDescription>
              {reflection.get('checklistItemDescription')}
            </ChecklistDescription>
          </div>
        );
      })}
    </>
  );
};

export default ChecklistReflectionSummary;
